function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UI-elements",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2813.000000, -681.000000)",
  id: "Tab-bezetting",
  stroke: "#425CD4",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2748.000000, 677.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "temperature-blue",
  transform: "translate(66.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.875,12.8483333 L6.875,3.125 C6.875,1.74428813 5.75571187,0.625 4.375,0.625 C2.99428813,0.625 1.875,1.74428813 1.875,3.125 L1.875,12.8483333 C0.597339803,13.9991601 0.267802406,15.8723056 1.07598139,17.3900884 C1.88416038,18.9078712 3.62226416,19.6800528 5.2903051,19.262372 C6.95834603,18.8446912 8.1274527,17.3445383 8.12500385,15.625 C8.12272982,14.5636753 7.66804432,13.5536673 6.875,12.8483333 L6.875,12.8483333 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.375,3.125 L4.375,14.375",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 4.375,
  cy: 15.625,
  r: 1.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4379185,8.5725 C17.458006,9.9143486 16.7536424,11.1629539 15.5947997,11.839744 C14.435957,12.516534 13.0023799,12.516534 11.8435372,11.839744 C10.6846946,11.1629539 9.98033093,9.9143486 10.0004185,8.5725 C10.0004185,5.385 13.1879185,1.66666667 13.7187518,1.66666667 C14.2495851,1.66666667 17.4379185,5.385 17.4379185,8.5725 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7187518,9.79166667 C13.0283959,9.79166667 12.4687518,9.2320226 12.4687518,8.54166667",
  id: "Path"
})))));
function SvgTemperatureBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "temperature blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureBlue);
export default __webpack_public_path__ + "static/media/temperature-blue.69d1d7faac8a7e3407e81d5c7099fa5a.svg";
export { ForwardRef as ReactComponent };